import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IllustrationComponent } from './illustration.component'; 

@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: IllustrationComponent }
    ])],
    exports: [RouterModule]
})
export class IllustrationRoutingModule { }